import type { Component } from 'vue'
import type { NombrePlantilla } from '../types/web'
import { encargoMinotaria, rutasMinotaria } from './minotaria'

/** Lo que una plantilla añade al encargo online. Sin este bloque el encargo es el de siempre. */
export interface EncargoPlantilla {
  /** Canal con el que se envían los encargos de esta web. */
  canal?: string
  /** Paso para elegir la notaría de destino, justo después del trámite. */
  pasoDestino?: Component
  /** Aviso de privacidad propio, en la revisión, antes de aceptar. */
  avisoPrivacidad?: Component
  /** Texto de la pantalla final cuando el encargo queda sin notaría de destino. */
  textoExitoSinDestino?: string
  /** Paso de "Qué pasa ahora" que sustituye a "La notaría revisa…" cuando el encargo queda sin notaría de destino. */
  siguienteSinDestino?: { titulo: string, texto?: string }
  /** No mostrar el teléfono de la web al cliente (solo el correo del panel). */
  sinTelefono?: boolean
  /** Campos que la plantilla añade al envío del encargo. */
  datosExtra?: () => Record<string, unknown>
}

/**
 * Registro de plantillas de la web pública. El código común solo conoce "la plantilla actual";
 * lo propio de cada plantilla (layout, rutas, encargo) se declara aquí.
 */
export interface Plantilla {
  nombre: NombrePlantilla
  /** Layout de la plantilla. Sin layout se usa el de siempre (default, o el que pida la página). */
  layout?: string
  /** Nombres de ruta (sin el prefijo "lang-") que existen en esta plantilla para la web dada. Sin lista, todas. */
  rutas?: (notaria: any) => string[]
  encargo?: EncargoPlantilla
  /** Icono de la pestaña del navegador. Sin él, el logo de la notaría o el favicon por defecto. */
  favicon?: string
}

const PLANTILLAS: Record<NombrePlantilla, Plantilla> = {
  notaria: { nombre: 'notaria' },
  // Plantilla 2 de notaría: mismos datos y secciones del panel, otro diseño (ref: https://trello.com/c/3g3PTnq5)
  notaria2: { nombre: 'notaria2', layout: 'notaria2' },
  // Plantilla 3 de notaría, «inmersiva» (ref: https://trello.com/c/MGgrmuPY)
  notaria3: { nombre: 'notaria3', layout: 'notaria3' },
  // Plantilla 4 de notaría, «editorial» (ref: https://trello.com/c/XU15s9gl)
  notaria4: { nombre: 'notaria4', layout: 'notaria4' },
  // Plantilla 5 de notaría, «panel lateral» (ref: https://trello.com/c/0Ma2vfxV)
  notaria5: { nombre: 'notaria5', layout: 'notaria5' },
  minotaria: { nombre: 'minotaria', layout: 'minotaria', rutas: rutasMinotaria, encargo: encargoMinotaria, favicon: '/minotaria-favicon.svg' },
}

export function obtenerPlantilla(nombre?: string | null): Plantilla {
  return PLANTILLAS[(nombre || '').toLowerCase() as NombrePlantilla] ?? PLANTILLAS.notaria
}
